import { render, staticRenderFns } from "./IconFullscreenExit.vue?vue&type=template&id=bf94256e&scoped=true"
import script from "./IconFullscreenExit.vue?vue&type=script&lang=js"
export * from "./IconFullscreenExit.vue?vue&type=script&lang=js"
import style0 from "./IconFullscreenExit.vue?vue&type=style&index=0&id=bf94256e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf94256e",
  null
  
)

export default component.exports